import type { JobItem } from "./types";

export function JobCard({ job }: { job: JobItem }) {
  return (
    <div className="flex flex-col gap-8 border-new-beginnings-tints-600 border-b pb-8 last:border-b-0 last:pb-0 md:flex-row md:items-start md:justify-between md:gap-10">
      <div className="flex flex-col gap-2 text-new-beginnings-base md:max-w-[672px]">
        <h3 className="font-bold text-md leading-7">
          {job.url ? (
            <a className="underline hover:no-underline" href={job.url}>
              {job.title}
            </a>
          ) : (
            job.title
          )}
        </h3>

        {job.jobSummary ? (
          <p className="line-clamp-2 text-base leading-6">{job.jobSummary}…</p>
        ) : null}
      </div>

      {job.url ? (
        <a
          className="inline-flex shrink-0 items-center justify-center self-start rounded-full border-2 border-new-beginnings-base bg-white px-6 py-3 font-semibold text-new-beginnings-base text-sm capitalize transition-colors hover:bg-new-beginnings-tints-800 hover:shadow-primary-button md:self-auto md:text-base"
          href={job.url}
        >
          <span className="md:hidden">Apply For This Job</span>
          <span className="hidden md:inline">View Job Details</span>
        </a>
      ) : null}
    </div>
  );
}
